import Http from '@services/httpClient';
import { ClientRequest } from '@common/ApiTypes';

const prefix = '/api/v1/invoices';

export default {
  list(page = 1, limit = 10, keyword = '', status = '') {
    return new Promise((resolve, reject) => {
      const req: ClientRequest = {
        // eslint-disable-next-line max-len
        url: `${prefix}/search?query=${keyword}&status=${status}&page=${page}&limit=${limit}`,
      };

      Http.get(req)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },

  sendInvoiceToEmail(invoiceNumber: string, email = '') {
    return new Promise((resolve, reject) => {
      Http.post({
        url: `${prefix}/send/email?number=${invoiceNumber}&email=${email}`,
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },
};
